import i18n from '@/lang/i18n'
import { ColDef } from '@ag-grid-enterprise/all-modules'
import { NotificationTemplatesModalType } from '@/modules/configurationModule/detail/notifications/components/notification-templates-modal/notification-templates-modal.model'
import { Nullable } from '@/shared/types/app.types'
import { CommonLaboratoryResponse, CommonUserappResponse } from '@/api/services/common.dto'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { getEnumColumnGridOptions } from '@/grid/base-grid-options'
import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'
import { notificationTemplatesService } from '@/modules/configurationModule/detail/notifications/services/notification-templates-service'
import { store } from '@/store/store'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'

export interface ContentCustomNotificationTextTemplateGrid {
    id: number
    active: boolean
    text: string
    title: string
    type: NotificationTemplatesModalType
    userapp: Nullable<CommonUserappResponse>
    laboratory: CommonLaboratoryResponse
}

export const columnsDefNotificationTemplatesGrid =
    (notificationTemplatesModalTypes: NotificationTemplatesModalType[]): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            headerName: i18n.tc('configuration.sections.template'),
            type: AgGridColumnType.TEXT,
            field: 'title',
            minWidth: 400,
            flex: 2
        },
        {
            ...getEnumColumnGridOptions(notificationTemplatesModalTypes, 'code', 'translatedName'),
            headerName: i18n.tc('configuration.grid.type'),
            type: AgGridColumnType.TEXT,
            colId: 'type',
            field: 'type.translatedName',
            minWidth: 400,
            flex: 2
        },
        {
            headerName: i18n.tc('configuration.grid.active'),
            type: AgGridColumnType.CHECK_ICON,
            field: 'active',
            flex: 1,
            minWidth: 80
        }
    ]

export interface NotificationsTemplatesGridState extends CrudModelPaginatorLaboratory<ContentCustomNotificationTextTemplateGrid> {
    service: typeof notificationTemplatesService
    laboratoryId: number
}
export const initialNotificationsTemplatesGridState =
    (): NotificationsTemplatesGridState => ({
        ...initialCrudModelBaseState(),
        service: notificationTemplatesService,
        laboratoryId: store.getters.labId,
        datasource: new PaginatorLaboratoryDatasource(notificationTemplatesService, store.getters.labId),
        columnsDef: columnsDefNotificationTemplatesGrid([]),
        gridUiComponent: 'uicomponent.configuration.local.notifications.templatesGrid'
    })
